import { APP_CONSTANTS } from "core/config";

const datePickerFormat = APP_CONSTANTS.REGEX_DATE_PICKER;

const dateAdapter = {
	parse(value = "", createDate) {
		const matches = value.match(datePickerFormat);
		if (matches) {
			return createDate(matches[3], matches[2], matches[1]);
		}
	},
	format(date) {
		return `${date.getDate()}.${
			date.getMonth() + 1
		}.${date.getFullYear()}`;
	}
};

const FormatToRequestDate = (dateString) => {
	if (!dateString || typeof dateString !== "string") return "";

	const year = dateString.substr(6, 4);
	const month = dateString.substr(3, 2);
	const day = dateString.substr(0, 2);

	return `${year}-${month}-${day}`;
};

const DateUtils = {
	FormatToRequestDate,
	datePickerFormat,
	dateAdapter
};

export default DateUtils;
